import React from 'react';
import { TiTick } from 'react-icons/ti';
import payment from '../src/Assets/payment.svg';

function PaymentSuccess() {
  return (
    <div className="w-screen h-screen flex justify-center pt-[20%] sm:pt-[10%]">
      <div className="space-y-8 flex flex-col items-center">
        <span className=" text-3xl sm:text-5xl text-green-600">Payment Successful</span> 
        <img className="w-40" src={payment} alt="success" />
        <span className="text-gray-400 px-14 text-xs sm:text-sm text-justify">Hurray !! We are delighted to inform you that we have received your payment</span>
      </div>
    </div>
  );
}

export default PaymentSuccess;
